import LangEnum from '../../../../lang/LangEnum';
import { findCustomers } from '../../../../services/modules/customers/customers.repository';
import type { FindCustomersData } from '../../../../services/modules/customers/customers.types';
import CatalogBatchAddEntityModal from './CatalogBatchAddEntityModal';

interface CatalogBatchAddCustomersModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (ids: string[]) => void;
}

const CatalogBatchAddCustomersModal = ({
  open,
  onClose,
  onConfirm,
}: CatalogBatchAddCustomersModalProps) => (
  <CatalogBatchAddEntityModal<FindCustomersData>
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    queryKeyBase="catalog-batch-add-customers"
    fetchFn={findCustomers}
    searchParam="query"
    defaultOrderBy={{ createdAt: 'DESC' as const }}
    titleKey={LangEnum.CATALOGS_BULK_ADD_CUSTOMERS_MODAL_TITLE}
    descriptionKey={LangEnum.CATALOGS_BULK_ADD_CUSTOMERS_MODAL_DESCRIPTION}
    searchEntityKey={LangEnum.GLOBAL_CUSTOMERS}
    getOptionLabel={(option) => option.commercialName}
  />
);

export default CatalogBatchAddCustomersModal;
